import { render, staticRenderFns } from "./PanelBackups.vue?vue&type=template&id=9106e140&scoped=true&"
import script from "./PanelBackups.vue?vue&type=script&lang=js&"
export * from "./PanelBackups.vue?vue&type=script&lang=js&"
import style0 from "./PanelBackups.vue?vue&type=style&index=0&id=9106e140&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9106e140",
  null
  
)

export default component.exports